// src/pages/Register.jsx
import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, set } from 'firebase/database';
import { auth, db } from '../firebase';
import { Link, useNavigate } from 'react-router-dom';
import '../css/Auth.css';

const Register = () => {
  const [fullName, setFullName] = useState('');
  const [school, setSchool] = useState('');
  const [userType, setUserType] = useState('');
  const [gender, setGender] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // ✅ Save additional user profile to database
      await set(ref(db, 'users/' + userId), {
        fullName,
        school,
        userType,
        gender,
        email,
      });

      navigate('/login');
    } catch (error) {
      setMsg(error.message);
    }
  };

  return (
    <div className="auth-container">
      <h2>Register for TanyaNow</h2>
      <form className="auth-form" onSubmit={handleRegister}>
        <input type="text" placeholder="Full Name" required onChange={(e) => setFullName(e.target.value)} />
        <input type="text" placeholder="School" required onChange={(e) => setSchool(e.target.value)} />

        <select required onChange={(e) => setUserType(e.target.value)} defaultValue="">
          <option value="" disabled>Choose User Type</option>
          <option value="Student">Student</option>
          <option value="Mentor">Mentor</option>
        </select>

        <select required onChange={(e) => setGender(e.target.value)} defaultValue="">
          <option value="" disabled>Choose Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>

        <input type="email" placeholder="Email" required onChange={(e) => setEmail(e.target.value)} />
        <input type="password" placeholder="Password" required onChange={(e) => setPassword(e.target.value)} />
        
        <button type="submit">Register</button>
        {msg && <p className="auth-message">{msg}</p>}
        <p className="auth-link">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </form>
    </div>
  );
};

export default Register;
